import type { FC, ReactNode } from 'react';
import { WebsiteJsonLd } from '@/base/WebsiteJsonLd';
import { Footer } from './Footer';
import { Header } from './Header';

export const DefaultLayout: FC<{
  children?: ReactNode;
  hideFooter?: boolean;
}> = ({ children, hideFooter = false }) => (
  <>
    <WebsiteJsonLd />
    <Header position="smart-sticky" />
    {children}
    {!hideFooter && <Footer />}
  </>
);
